import jwtDecode from 'jwt-decode'

const state = {
  isLoggedIn: !!sessionStorage.getItem('token'),
  token: sessionStorage.getItem('token')
}

const getters = {
  isLoggedIn: state => state.token !== null,
  token: state => state.token,
  currentUser: state => state.token !== null || state.token !== undefined ? jwtDecode(state.token) : null
}

const actions = {
  setToken ({ commit }, token) {
    commit('setToken', token)
  },
  deleteToken ({ commit }) {
    commit('deleteToken')
  }
}

const mutations = {
  setToken (state, token) {
    state.token = token
    sessionStorage.setItem('token', token)
  },
  deleteToken (state) {
    state.token = null
    sessionStorage.removeItem('token')
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/auth.js